// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_5c94439","backNext":"_0462aa2","back":"_6bad414","reset":"_c82596c","next":"_fae21f0","mobile":"_a0b49f1"};